import { render } from "./PlusFilledYellowIcon.vue?vue&type=template&id=0f36acca"
import script from "./PlusFilledYellowIcon.vue?vue&type=script&lang=js"
export * from "./PlusFilledYellowIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__